export default "<p>search works!</p>\n";